"use strict";

var withBreakpointsCustom = require('./withBreakpointsCustom').default;

module.exports = {
  withBreakpointsCustom: withBreakpointsCustom
};